/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// tslint:disable: no-array-mutation
// tslint:disable: no-expression-statement
/**
 * @documentation true
 * @sectionName Async
 */
import { isArray } from './guards';
import { keys, pipe, sortKeys } from './index';
import { hashCode } from './utils';
/**
 * Interface implemented by all widgets.
 * @public
 */
export function range(end, start = 0) {
    return new Array(end).fill(1).map((_v, index) => {
        return index + start;
    });
}
export function concat(...items) {
    return (current) => {
        return current.concat(...items);
    };
}
export function reverse(data) {
    if (!data) {
        return (d) => {
            return reverse(d);
        };
    }
    return data.reduce((rev, value) => {
        rev.push(value);
        return rev;
    }, []);
}
export function filter(...args) {
    if (args.length === 2) {
        const data = args[1];
        const fn = args[0];
        return data.filter((value, index, arr) => {
            return !!fn(value, index, arr);
        });
    }
    return (dx) => {
        return dx.filter((value, index, arr) => {
            return args[0](value, index, arr);
        });
    };
}
export function every(fn, data) {
    if (!data) {
        return (d) => {
            return every(fn, d);
        };
    }
    return data.every((a, index, arr) => {
        return !!fn(a, index, arr);
    });
}
export function partition(fn, data) {
    if (!data) {
        return (d) => {
            return partition(fn, d);
        };
    }
    const pass = data.filter(fn);
    const fails = data.filter((value, index, arr) => {
        return !fn(value, index, arr);
    });
    return [pass, fails];
}
function __flatten(arr, depth) {
    return depth !== undefined && depth <= 0
        ? arr
        : Array.isArray(arr)
            ? arr.reduce((acc, v) => acc.concat(__flatten(v, depth !== undefined ? depth - 1 : undefined)), [])
            : [arr];
}
export function flatten(...args) {
    if (args.length === 2) {
        const data = args[1];
        const depth = args[0];
        return __flatten(data, depth);
    }
    if (args.length === 0) {
        return (data) => {
            return __flatten(data, 1);
        };
    }
    return (data) => {
        const depth = args[0];
        return __flatten(data, depth);
    };
}
export function map(fn, data) {
    if (!data) {
        return (d) => {
            return d.map(fn);
        };
    }
    return data.map(fn);
}
export function flatMap(fn, data) {
    if (!data) {
        return (d) => d.reduce((acc, curr, index) => [...acc, ...fn(curr, index, data)], []);
    }
    return data.reduce((acc, curr, index) => [...acc, ...fn(curr, index, data)], []);
}
export function reduce(fn, initial, data) {
    if (!data) {
        return (d) => {
            return d.reduce(fn, initial);
        };
    }
    return data.reduce(fn, initial);
}
export function unique(...args) {
    // tslint:disable
    const primitives = {
        number: {},
        string: {},
        boolean: {},
        hascode: {},
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const filterFn = (data, _index, _arr) => {
        if (typeof data === 'number') {
            if (data in primitives.number) {
                return false;
            }
            primitives.number[data] = true;
            return true;
        }
        if (typeof data === 'string') {
            if (data in primitives.string) {
                return false;
            }
            primitives.string[data] = true;
            return true;
        }
        if (typeof data === 'boolean') {
            const b = data ? 1 : 0;
            if (b in primitives.boolean) {
                return false;
            }
            primitives.boolean[b] = true;
            return true;
        }
        const hash = hashCode(JSON.stringify(sortKeys(data)));
        if (hash in primitives.hascode) {
            return false;
        }
        primitives.hascode[hash] = true;
        return true;
    };
    if (args.length === 1) {
        return filter(filterFn)(args[0]);
    }
    return filter(filterFn);
    // tslint:enable
}
export function uniqueByFunc(fn, data) {
    if (!data) {
        return (d) => {
            return uniqueByFunc(fn, d);
        };
    }
    return pipe(data, map((current) => {
        return {
            matcher: fn(current),
            data: current,
        };
    }), uniqueBy('matcher'), map((result) => result.data));
}
export function uniqueBy(...args) {
    const key = args[0];
    if (args.length === 2) {
        const uniqV = pipe(args[1], map((d) => {
            return d[key];
        }), map((v, index, arr) => {
            if (index === arr.indexOf(v)) {
                return v;
            }
            return;
        }));
        return pipe(args[1], filter((_, index) => {
            return !!uniqV[index];
        }));
    }
    return (data) => {
        return uniqueBy(key, data);
    };
}
export function scan(fn, initial, data) {
    if (!data) {
        return (d) => {
            return scan(fn, initial, d);
        };
    }
    return data.map((_v, index, arr) => {
        return arr.slice(0, index + 1).reduce(fn, initial);
    });
}
function __sort(a, compareFn) {
    return [...a].sort(compareFn);
}
export function sort(...args) {
    if (args.format === 2) {
        return __sort(args[1], args[0]);
    }
    return (data) => {
        return __sort(data, args[0]);
    };
}
export function select(xKeys) {
    if (Array.isArray(xKeys)) {
        return (data) => {
            return pipe(data, map((c) => {
                return xKeys.reduce((acc, current) => {
                    return Object.assign({}, acc, { [current]: c[current] });
                }, {});
            }));
        };
    }
    return (data) => {
        return pipe(data, map((v) => v[xKeys]));
    };
}
export function chunk(len, data) {
    if (!data) {
        return (d) => {
            return chunk(len, d);
        };
    }
    // tslint:disable
    let chunks = [], i = 0, n = data.length;
    while (i < n) {
        chunks.push(data.slice(i, (i += len)));
    }
    // tslint:enable
    return chunks;
}
export function groupBy(fn, data) {
    if (!data) {
        return (d) => {
            return groupBy(fn, d);
        };
    }
    return data.reduce((acc, current) => {
        const xKeys = fn(current);
        const ensuredArrayOfKeys = (Array.isArray(xKeys) ? xKeys : [xKeys]);
        return Object.assign({}, acc, ensuredArrayOfKeys.reduce((acc2, key) => {
            return Object.assign({}, acc2, { [key]: acc[key] ? [...acc[key], current] : [current] });
        }, {}));
    }, {});
}
export function take(count, data) {
    if (!data) {
        return (d) => {
            return d.slice(0, count);
        };
    }
    return data.slice(0, count);
}
export function takeLast(count, data) {
    if (!data) {
        return (d) => {
            return d.slice(d.length - count, d.length);
        };
    }
    return data.slice(data.length - count, data.length);
}
export function first(data) {
    if (data) {
        if (data.length === 0) {
            return;
        }
        return data[0];
    }
    return (d) => {
        return first(d);
    };
}
export function last(data) {
    if (data) {
        if (data.length === 0) {
            return;
        }
        return data[data.length - 1];
    }
    return (d) => {
        return first(d);
    };
}
/**
 * Ensures that we have array
 * @param a - Array or item
 */
export function makeArray(a) {
    return Array.isArray(a) ? a : [a];
}
export function shuffle(data) {
    if (!data) {
        return (d) => {
            return shuffle(d);
        };
    }
    // tslint:disable
    const a = [...data];
    for (let i = a.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    // tslint:enable
    return a;
}
export function duplicates(arr) {
    if (!arr) {
        return (q) => {
            return duplicates(q);
        };
    }
    const d = arr.filter((c, index) => {
        return arr.indexOf(c) !== index;
    });
    return arr.filter((c) => {
        return d.includes(c);
    });
}
export function duplicatesBy(fn, arr) {
    if (!arr) {
        return (d) => {
            return duplicatesBy(fn, d);
        };
    }
    const i = arr.map(fn);
    const dup = duplicates(i);
    return arr.filter((c) => {
        return dup.includes(fn(c));
    });
}
/**
 * Filters data with provided object. And returns correct type
 */
export function filterByType(type) {
    return (d) => {
        const k = keys(type);
        return k.every((u) => d[u] === type[u]);
    };
}
export function includesSomeOf(includes, data) {
    if (!data) {
        return (d) => {
            return includesSomeOf(includes, d);
        };
    }
    return data.some((q) => includes.includes(q));
}
export function includesEveryOf(includes, data) {
    if (!data) {
        return (d) => {
            return includesEveryOf(includes, d);
        };
    }
    return includes.every((d) => {
        return data.includes(d);
    });
}
export function ensureArray(value) {
    return isArray(value) ? value : [value];
}
export function join(separator) {
    return (data) => {
        return data.join(separator);
    };
}
export function reduceToRecord(reducer, items) {
    if (!items) {
        return (q) => {
            return reduceToRecord(reducer, q);
        };
    }
    // tslint:disable-next-line: no-object-literal-type-assertion
    const data = {};
    // tslint:disable-next-line: no-loop-statement
    for (const x of items) {
        const id = reducer(x);
        // tslint:disable
        data[id] = x;
    }
    return data;
}
